import React from 'react';
import './ScanSuccess.css';

const ScanSuccess = ({ onClose, onCreateTeam, result }) => {
  const isPending = result?.pending === true;
  const receipt = result?.receipt || result?.data || {};
  const tickets = Math.floor(result?.tickets || receipt?.calculated_tickets || 0);
  const txCode = receipt?.qr_code || '-';
  const totalAmount = Math.floor(receipt?.total_amount || result?.data?.total_amount || 0);
  const multiplier = result?.multiplier || receipt?.multiplier || 1;
  const isNewMember = result?.isNewMember || receipt?.is_new_member || false;

  return (
    <div className="bts-scan-success">
      <div className="bts-scan-success__trophy-wrap">
        <span className="bts-scan-success__trophy-icon">{isPending ? '📋' : '🏆'}</span>
      </div>

      <h2 className="bts-scan-success__title">
        {isPending ? 'บันทึกแล้ว!' : 'สแกนสำเร็จ!'}
      </h2>

      {isPending && (
        <p className="bts-scan-success__pending-note">
          บิลถูกเก็บไว้รอ — เมื่อคุณมีทีมแล้วจะคำนวณคะแนนให้อัตโนมัติ
        </p>
      )}

      {!isPending && (
        <div className="bts-scan-success__points-card">
          <p className="bts-scan-success__points-label">คะแนนที่ได้รับ</p>
          <div className="bts-scan-success__points-row">
            <p className="bts-scan-success__points-value">+{tickets.toLocaleString()}</p>
            {multiplier > 1 && (
              <span className="bts-scan-success__multiplier">x{multiplier}</span>
            )}
          </div>
          <p className="bts-scan-success__points-unit">คะแนน</p>
          {isNewMember && (
            <p className="bts-scan-success__bonus-text">🌟 สมาชิกใหม่รับคะแนน {multiplier} เท่า!</p>
          )}
        </div>
      )}

      <div className="bts-scan-success__info-grid">
        <div className="bts-scan-success__info-box">
          <p className="bts-scan-success__info-label">เลขบิล</p>
          <p className="bts-scan-success__info-value">{receipt?.receiptNo || receipt?.qr_code?.split('_').pop() || txCode}</p>
        </div>
        <div className="bts-scan-success__info-box">
          <p className="bts-scan-success__info-label">ยอดซื้อ</p>
          <p className="bts-scan-success__info-value">฿{totalAmount.toLocaleString()}</p>
        </div>
      </div>

      <div className="bts-scan-success__actions">
        {isPending && onCreateTeam ? (
          <>
            <button className="bts-scan-success__share-btn" onClick={onCreateTeam}>
              สร้างทีมเลย!
            </button>
            <button className="bts-scan-success__share-btn" style={{ background: '#888', marginTop: 8 }} onClick={onClose}>
              กลับหน้าหลัก
            </button>
          </>
        ) : (
          <button className="bts-scan-success__share-btn" onClick={onClose}>
            กลับหน้าหลัก
          </button>
        )}
      </div>
    </div>
  );
};

export default ScanSuccess;
